import React, { useState } from "react";
import "./Accordion.css";

const Accordion = ({ items, onClickHandler = () => {} }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="accordion">
      {items.map((item, index) => (
        <div key={index} className="accordion__item">
          <div className="accordion__header" onClick={() => toggle(index)}>
            <span className="accordion__sign">
              {activeIndex === index ? "-" : "+"}
            </span>
            <span className="accordion__title">{item.title}</span>
            <span className="accordion__cta">
              {(activeIndex === index || selectedIndex === index) && (
                <button
                  className={`select__btn ${
                    selectedIndex === index ? "selected" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickHandler(item.title);
                    setSelectedIndex(index);
                  }}
                >
                  Select{selectedIndex === index && <span> &#10003;</span>}
                </button>
              )}
            </span>
          </div>
          {activeIndex === index && (
            <div className="accordion__body">
              <p>{item.text}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
